export default __webpack_public_path__ + "static/combination-of-different-series-types-16fb73a0ed4cf5da668d0c21cc08fcf9.png";